import * as React from "react";
import { InsuranceInfo } from "../patient-portal/InsuranceInfo";
import InsuranceInformationItemsList from "./InsuranceInformationItemsList";

export default function PatientInsuranceInformationPanel({
  title,
  insuranceInformation,
  secondaryInsuranceInfo,
}: {
  title: string;
  insuranceInformation?: InsuranceInfo;
  secondaryInsuranceInfo?: InsuranceInfo;
}) {
  return (
    <div className="insurance-information-panel panel">
      <div className="panel-title h-flex space-between no-wrap">
        <div>{title}</div>
      </div>
      {insuranceInformation ? (
        insuranceInformation.hasInsurance ? (
          <>
            <InsuranceInformationItemsList
              insuranceInfo={insuranceInformation}
              title="Page.Portal.InsuranceInformation.PrimarySubTitle"
            />
            {secondaryInsuranceInfo && (
              <InsuranceInformationItemsList
                insuranceInfo={secondaryInsuranceInfo}
                title="Page.Portal.InsuranceInformation.SecondarySubTitle"
              />
            )}
          </>
        ) : (
          <div className="centered">
            <span className="no-information-message">
              {i18n["Page.Patient.FullDetails.InsuranceInformation.DontHaveInsurance"]}
            </span>
          </div>
        )
      ) : (
        <div className="centered">
          <span className="no-information-message">
            {i18n["Page.Patient.FullDetails.Information.NotFilled"]}
          </span>
        </div>
      )}
    </div>
  );
}
